import React, { useState, useLayoutEffect } from "react";
import { useQuery } from "@apollo/client";
import { GET_LIKED_ENTRIES } from "../../queries/queries";
import Error from "../error";
import Loading from "../loading";
import Entry from "./Entry";
import NewsModal from "./NewsModal";
import { useLocation } from "react-router-dom";
import useMakeScrollable from "../../custom_hooks/make-scrollable";
import classNames from "classnames";
import NoResultPage from "components/thankyou/noresult-page";

function FavoritesList({ setShowHeart, setEntryId, likedList, ...props }) {
  const [showEntryList, setShowEntryList] = useState(true);
  const [showIframeUrl, setShowIframeUrl] = useState("");

  useMakeScrollable()

  const likedFeeds = useQuery(GET_LIKED_ENTRIES, {
    fetchPolicy: "no-cache",
  });

  const location = useLocation();
  useLayoutEffect(() => {
    document.documentElement.scrollTo({ top:0, left:0, behavior: "instant" });
}, [location.pathname]);

  if (likedFeeds.loading) return <Loading />;
  if (likedFeeds.error) return <Error />;
  if (!likedFeeds.data.getLikedEntries.length) return  <NoResultPage text={'Es sind leider keine Favoriten vorhanden, die angezeigt werden können.'} />

  const url = likedFeeds.data.getLikedEntries.url;

  let content = <NewsModal url={showIframeUrl} />;
  if (showEntryList) {
    content = likedFeeds.data.getLikedEntries.map((entry, index) => {
      return (
        <Entry
          index={index}
          key={index}
          id={entry.id}
          title={entry.titel}
          excerpt={entry.excerpt}
          slug={entry.url}
          url={url}
          setShowIframeUrl={setShowIframeUrl}
          baseUrl={entry.baseUrl}
          setShowEntryList={setShowEntryList}
          logo={entry.logoUrl}
          setShowHeart={setShowHeart}
          setEntryId={setEntryId}
        />
      );
    });
  }
  const feedClassName = classNames({
    "feed-iframe": !showEntryList,  
    "feed-list": showEntryList,  
  });

  return (
    <div className="scrollable">
      <div className={feedClassName}>{content}</div>
    </div>
  );
}

export default FavoritesList;
